export default __webpack_public_path__ + "static/media/Peppers.083fb8e8.jpg";